import { Component, OnInit } from '@angular/core';
import { IntercomService } from 'src/app/services/intercom/intercom.service';

@Component({
  selector: 'app-intercom',
  template: '',
  styleUrls: [],
  providers: [IntercomService]
})
export class IntercomComponent {

  constructor(private intercomService: IntercomService) { }

}
